import { vuexTypes } from '../types'
import { notificationsService } from '@api/notifications.service'
import { CRYPTO_CURRENCYS } from '@utils/consts'

function roundCurrency2 (input) {
  let num = parseFloat(input)
  let formatted = num.toFixed(6)
  let trimmed = parseFloat(formatted).toString()
  if (!trimmed.includes('.')) {
    trimmed += '.00'
  } else {
    let parts = trimmed.split('.')
    if (parts[1].length < 2) {
      trimmed += '0'.repeat(2 - parts[1].length)
    }
  }
  return trimmed
}

const state = {
  messages: [],
  sseInitiated: false
}

const mutations = {
  UPDATE_MESSAGES (state, messages) {
    state.messages = messages.map(el => {
      return {
        ...el,
        params: {
          ...el.params,
          amount: Object.values(CRYPTO_CURRENCYS).includes(el.params.asset) || el.params.asset.endsWith('20D') ? roundCurrency2(Number(el.params.amount)) : el.params.amount,
          asset: el.params.asset.startsWith('USDT') ? el.params.asset.replace(/^USDT/, 'USDT ').replace(/(?<=20)D$/, '') : el.params.asset
        }
      }
    }).sort((a, b) => new Date(b.updated_at) - new Date(a.updated_at))
  },
  /**
   *
   * @param state
   * @param event MessageEvent
   * @constructor
   */
  SSE_NEW_MESSAGES (state, event) {
    if (event.data === 'null') {
      return
    }

    const array = JSON.parse(event.data)
    for (const message of array) {
      state.messages.push(message)
    }
    state.messages = state.messages.map(el => {
      return {
        ...el,
        params: {
          ...el.params,
          amount: Object.values(CRYPTO_CURRENCYS).includes(el.params.asset) || el.params.asset.endsWith('20D') ? roundCurrency2(Number(el.params.amount)) : el.params.amount,
          asset: el.params.asset.startsWith('USDT') ? el.params.asset.replace(/^USDT/, 'USDT ').replace(/(?<=20)D$/, '') : el.params.asset
        }
      }
    }).sort((a, b) => new Date(b.updated_at) - new Date(a.updated_at))
  }
}

const actions = {
  async GET_UNREAD_MESSAGES ({ state, commit }) {
    if (!state.sseInitiated) {
      notificationsService.sse((event) => commit(vuexTypes.SSE_NEW_MESSAGES, event))
    }
    const resp = await notificationsService.loadUnreadNotifications()
    if (resp._parsedData.messages) {
      const uniqueArray = resp._parsedData.messages.filter((value, index, self) =>
        index === self.findIndex((t) => t.id === value.id)
      )
      commit(vuexTypes.UPDATE_MESSAGES, uniqueArray)
    } else {
      commit(vuexTypes.UPDATE_MESSAGES, [])
    }
  },
  async MARK_READ_MESSAGES ({ state, commit }, filter) {
    await notificationsService.readMessages(filter)
    let buf = []
    for (const message of state.messages) {
      if (filter.indexOf(message.id) === -1) {
        buf.push(message)
      }
      commit(vuexTypes.UPDATE_MESSAGES, buf)
    }
  }
}

const getters = {
  getUnreadMessages: state => state.messages
}

export default {
  actions,
  getters,
  mutations,
  state
}



// WEBPACK FOOTER //
// ./src/vuex/modules/notifications.module.js